import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import SectionWrapper from './ui/SectionWrapper';
import { GOALS, goToApp } from '../constants';

const Goals = () => (
  <SectionWrapper id="use-cases" eyebrow="Built for every creator" title="Tailored for your goals." className="bg-slate-50">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {GOALS.map(({ title, desc, icon: Icon, color, image }, i) => (
        <motion.button
          key={title}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.08 }}
          onClick={goToApp}
          className="group relative text-left h-[340px] rounded-2xl overflow-hidden bg-[#141020] flex flex-col justify-start"
          data-testid={`goal-card-${i}`}
        >
          <img src={image} alt={title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#120d22] via-[#120d22]/70 to-transparent" />
          <div className="relative p-5 flex gap-3">
            <span className={`w-11 h-11 shrink-0 rounded-full bg-gradient-to-br ${color} flex items-center justify-center text-white`}><Icon size={20} /></span>
            <span>
              <span className="block font-display font-bold text-white">{title}</span>
              <span className="block text-sm text-white/75 mt-1 leading-snug">{desc}</span>
            </span>
          </div>
          <span className="absolute right-4 bottom-4 w-10 h-10 rounded-full bg-black/50 border border-white/40 backdrop-blur flex items-center justify-center text-white transition-[background-color,transform] duration-300 group-hover:bg-brand group-hover:translate-x-0.5">
            <ArrowRight size={18} />
          </span>
        </motion.button>
      ))}
    </div>
  </SectionWrapper>
);

export default Goals;
